module.exports = __webpack_public_path__ + "static/img/share4-3.f13466e7.png";